import React, { Component } from 'react'
import { observer } from 'mobx-react'

import {
    Button,
    Col,
    Grid,
    Row
} from 'react-bootstrap'

import InvoiceDetails from './invoicedetails'

@observer(['agreements', 'invoices', 'quickbooks', 'globals'])
export default class FleetView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            signature: ''
        }
    }

    //State Change Handlers
    signatureChanged(e) {
        this.setState({
            signature: e.target.value
        })
    }

    render() {
        var signaturePanel = (
            <div className="row small-top-margin hidden-print">
                <div className="col-xs-12">
                    <div class="form-group">
                        <label class="small-top-margin control-label col-md-3 col-sm-3 col-xs-12">
                            Electronic Signature: By typing your full name below, you agree to be bound by the terms and conditions detailed above.
                        </label><br />
                        <input type="text" className="form-control show-border" onChange={this.signatureChanged.bind(this)} placeholder="" />
                    </div>
                </div>
            </div>
        )

        let paymentNotification = ''
        let buttonDisplay = <Button className="btn btn-success pull-right fa fa-credit-card" onClick={() => { this.props.redirectProcessPaymentPage(this.props.invoices.invoiceViewDetails.invoiceId, this.state.signature) }}><i></i> Submit Payment</Button>

        if (this.props.invoices.invoiceViewDetails.paymentId !== null) {
            paymentNotification = <h2><strong>YOU HAVE ALREADY PROCESSED A PAYMENT FOR THIS INVOICE!</strong></h2>
            buttonDisplay = <Button disabled className="btn btn-success pull-right fa fa-credit-card" ><i></i> Payment Already Processed</Button>
            signaturePanel = ''
        }

        return (
            <div className="checkout-container fleet-body">
                <Grid>
                    <Row>
                        <Col xs={0} md={2}></Col>
                        <Col xs={12} md={8}>
                            <Row className="hidden-print center">
                                <Col>
                                    {paymentNotification}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="fleet-quote-logo">
                                    <p><a href="https://gpsleaders.com/" target="_blank;" rel="noopener"><img src="https://gpsleaders.com/wp-content/uploads/2017/09/gpsl-logo-150.png" /></a></p>
                                </Col>
                            </Row>
                            <Row className="pagebreak-print">
                                <Col className="main-title-section">
                                    <h1>GPS Leaders Proposal</h1>
                                    <h4 style={{ color: '#656565' }}>By: {this.props.invoices.invoiceViewDetails.userFullName}</h4>
                                    <h4 style={{ marginBottom: '0px' }}><a href={ 'mailto:' + this.props.invoices.invoiceViewDetails.userEmail} target="_blank"><span style={{ color: '#656565', fontWeight: '400', fontSize: '20px' }}>{this.props.invoices.invoiceViewDetails.userEmail}</span></a></h4>
                                    <h4 style={{ marginTop: '0px' }}><a href="tel:+18554326423"><span style={{ color: '#656565', fontWeight: '400', fontSize: '20px' }}>(855) 432-6423</span></a></h4>
                                </Col>
                            </Row>
                            {/*
                            <Row>
                                <Col className="main-sub-section">
                                  <h2>Introducing GPS Leaders, LLC</h2>
                                  <p>A leader in GPS Tracking devices with over 25 years in the business. We put our customers 1st and work hard to make sure our clients are not just getting high quality products at a great price but also excellent customer service.</p>
                                  <h2>Life Time Manufactures Warranty</h2>
                                  <p>We are committed to providing top-quality hardware and solutions to our customers. If our GPS device stops performing for the life of the device, we’ll replace it free of charge, no questions asked.</p>
                                </Col>
                            </Row>
                            <Row>
                              <Col className="main-sub-section pagebreak-print">
                                <h3 style={{ textAlign: 'center', marginTop: '40px' }}>Check Out Our Latest Reviews</h3>
                                <div className="row-widgets reviews-widgets">
                                  <span style={{ margin: '10px 0px' }} className="col"><a href="https://www.google.com/search?q=gps+leaders&oq=gps+leaders+&aqs=chrome..69i57j69i60l3j0l2.2607j0j4&sourceid=chrome&ie=UTF-8#lrd=0x80db7c5394ee2a9d:0x225cb0c68ed10c14,1,,," target="_blank;" rel="noopener"><img src="https://gpsleaders.com/wp-content/uploads/2017/11/google-reviews.png" /></a></span>
                                  <span style={{ margin: '10px 0px' }} className="col"><a href="https://www.facebook.com/pg/gpsleaders/reviews/" target="_blank;" rel="noopener"><img src="https://gpsleaders.com/wp-content/uploads/2017/11/fb-review-btn.png" /></a></span>
                                  <span style={{ margin: '10px 0px' }} className="col"><a href="https://www.capterra.com/p/146426/GPS-Leaders/" target="_blank;" rel="noopener"><img src="https://gpsleaders.com/wp-content/uploads/2017/11/capterra.png" /></a></span>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <h1 style={{ textAlign: 'center', marginTop: '20px', color: '#0070ff' }}>An Introduction To GPS Leaders EZ Fleet</h1>
                              </Col>
                            </Row>
                            <Row className="row-widgets ez-fleet-container hidden-print">
                                <Col className="col">
                                  <div className="ez-fleet-intro">
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/bRsEUF1u844?autoplay=0&amp;rel=0&amp;enablejsapi=1&amp;wmode=opaque" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="col">
                                  <div style={{ textAlign: 'center', marginTop: '50px' }}>
                                    <h3 style={{ marginBottom: '30px' }}>How Much Will You Save with our Fleet Management Solution?</h3>
                                      <p style={{ margin: '0px' }}>Reduce Time Theft by up to 50%</p>
                                      <p style={{ margin: '0px' }}>Reduce Fuel Consumption company wide by as much as 25%</p>
                                      <p style={{ margin: '0px' }}>Reduce traffic fines by up to 25% with Driver Behavior Reporting</p>
                                      <p style={{ margin: '0px' }}>Increased Employee Productivity by as much as 40%</p>
                                  </div>
                              </Col>
                            </Row>
                            <Row style={{ marginTop: '20px' }}>
                              <Col className="pagebreak-print">
                                <center><img src="https://gpsleaders.com/wp-content/uploads/2018/12/fleet_collage.jpg" /></center>
                              </Col>
                            </Row>
                            <Row  className="pagebreak-print" style={{ marginTop: '20px' }}>
                              <Col>
                              <center><img style={{ width: '150px'}} src="https://gpsleaders.com/wp-content/uploads/2018/12/money_symbol.png" /></center>
                              <h3 style={{ textAlign: 'center', marginBottom: '20px' }}><strong>How You Get More for Your Money</strong></h3>
                                <div style={{ maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
                                  <p><strong>Speeding</strong> - Reduce risk of insurance hikes, lower risk of auto accidents and tickets. Reduce Fuel cost, example: For every 1 mph over 60 / cost can cost you up to $.71 per gallon. Extend tire life, example: Driving over 70 mph can double the wear & tear of your tires.</p>
                                  <p><strong>Idling</strong> - Places invisible miles on vehicle, cutting 15 minutes of idling out of each day saves could save as much as $800/vehicle annually. Example, 1 Hour of idling = 25 miles of driving, which equates to twice as much gas as driving.</p>
                                  <p><strong>Tracking</strong> - Places you in the passenger seat of every vehicle, security feature for anti-theft, can see where vehicle is at all times, tells a story of what’s happening with your fleet at a glance.</p>
                                  <p><strong>Efficiency</strong> - Shows how long it takes to get from one job to another. Shows how long employees were on the job site. Provides a virtual time clock at each location.</p>
                                  <p><strong>Hard breaking</strong> - Reduce wear on brake pads, reduces trips to the mechanic, lower maintenance cost.</p>
                                  <p><strong>Rapid acceleration</strong> - Consumes approx. 3 gallons of gas more than normal driving behavior, reduce accidents, reduces engine wear and tear.</p>
                                  <p><strong>Landmarks</strong> - Great for accountability for employees who take their vehicles home, Creates a virtual time clock, Eliminate negative company exposure, job cost confirmation, can be notified immediately when a landmark event has occurred. Alerts when event occurs.</p>
                                  <p><strong>GeoFences</strong> - Small/ large area, automatic alert when fence is breached, unlimited geofences, keeps employees away from where they should not be.</p>
                                  <p><strong>Maps</strong> – Real time, ability to track employees, information is stored for a year, can track from day one.</p>
                                  <p><strong>Nearest Vehicle</strong> - Most efficient way to find nearest vehicle for to address, reduce fuel cost & unnecessary wear and tear on your vehicle.</p>
                                  <p><strong>Vehicle Maintenance</strong> - Tracking of engine miles, user definable maintenance scheduling, eliminate late fees, compliance with regulatory commission standards, safety for drivers.</p>
                                  <p><strong>Reports</strong> - Can run up to 30 various reports i.e. details, millage summary, speed, idling, etc. To track individuals and or fleet.</p>
                                  <p><strong>Stops</strong> - Reduces Time Theft which is the #1 crime in America today, stop over extended lunches & stops, driver randevu's, unauthorized stops, etc.</p>
                                </div>
                              </Col>
                            </Row>
                            <Row style={{ textAlign: 'center', maxWidth: '800px', marginTop: '40px', marginLeft: 'auto', marginRight: 'auto' }}>
                              <Col>
                                <h3><em><strong>“Southside Plumbing, with five company vehicles we saved $800 the first month using GPS Leaders when we noticed our employees were leaving the job site early on a daily basis”<br /><br />"24 Hour Sweepers, found that ALL their drivers were stealing time from the company averaging approximately 8 hours a day, saving $32,000 a month in time theft."</strong></em></h3>
                              </Col>
                            </Row>
                            <Row  className="pagebreak-print" style={{ marginTop: '20px', textAlign: 'center' }}>
                              <Col>
                                <img src="https://gpsleaders.com/wp-content/uploads/2018/12/fleet_software.png" />
                                </Col>
                            </Row>
                            */}
                            <Row className="pagebreak-print">
                                <Col>
                                    <InvoiceDetails token={this.props.token} emailStatus={true} setLoadableState={ this.props.setLoadableState.bind(this) }/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="row hidden-print">
                                        <div className="col-xs-12">
                                            <p className="lead">Terms and Conditions</p>
                                            <div className="agreement-container small-top-margin">
                                                {this.props.invoices.invoiceViewDetails.agreementDetails}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row visible-print">
                                        <div className="col-xs-12">
                                            <p className="lead">Terms and Conditions</p>
                                            <div className="agreement-container-print small-top-margin">
                                                {this.props.invoices.invoiceViewDetails.agreementDetails}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row small-top-margin visible-print">
                                        <div className="col-xs-12">
                                            <div class="form-group">
                                                <label class="small-top-margin control-label col-md-3 col-sm-3 col-xs-12">
                                                    By signing your full name below, you agree to be bound by the terms and conditions detailed above.
                                                </label>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>Signature: </td>
                                                            <td>________________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Name: </td>
                                                            <td>________________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date: </td>
                                                            <td>________________________________</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    { signaturePanel }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="row small-top-margin hidden-print">
                                        <div className="col-xs-12">
                                            {buttonDisplay}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={0} md={2} />
                    </Row>
                </Grid>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/invoices/fleetview.js